<template>
  <el-switch
    v-model="value"
    :off-text="options[0].label"
    :on-text="options[1].label"
    :off-color="options[0].style | color"
    :on-color="options[1].style | color"
    :width="width"
    @change="changeValue">
  </el-switch>
</template>

<script>
  export default {
    props: {
      width: {
        type: Number,
        default: 80
      },
      disabled: {
        type: Boolean,
        default: false
      },
      dataType: {
        type: String,
        default: 'number'
      },
      currentValue: {
        type: Boolean
      },
      options: {
        type: Array,
        default: () => []
      }
    },
    data () {
      return {
        value: this.currentValue
      }
    },
    filters: {
      color (style) {
        if (style === 'success') {
          return '#58d68d'
        }
        if (style === 'primary') {
          return '#03a9f4'
        }
        if (style === 'info') {
          return '#03a9f4'
        }
        if (style === 'warning') {
          return '#ffcd14'
        }
        if (style === 'danger') {
          return '#fe6553'
        }
      }
    },
    methods: {
      changeValue (value) {
        this.$emit('changeValue', value)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// SmartSwitch.vue?954b6398